export default class CustomNotificationCtrl{

  constructor($scope, $state, GeneralSettingsSrv,$stateParams,$timeout,$cookies, Validations){
    var customNotificationVm = this
    const user = JSON.parse($cookies.get('currentUser'))
    const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

    customNotificationVm.faculties = {}
    customNotificationVm.teachers = {}
    customNotificationVm.deliveryType = {}
    customNotificationVm.submodules = {}
    customNotificationVm.notificationTypes = {}
    customNotificationVm.selectedDeliveryType = []
    customNotificationVm.isDisabled = false
    customNotificationVm.selectedTeachers = [] // Autocomplete
    customNotificationVm.deliveryDate = null
    customNotificationVm.minDate = new Date()

    customNotificationVm.toggle = toggle
    customNotificationVm.exists = exists
    customNotificationVm.saveCustomNotification = saveCustomNotification
    customNotificationVm.addTeacher = addTeacher
    customNotificationVm.removeTeacher = removeTeacher
    customNotificationVm.searchTeacher = searchTeacher
    customNotificationVm.hasError = hasError
    customNotificationVm.showErrorMessages = showErrorMessages
    customNotificationVm.validateForm = validateForm
    customNotificationVm.changeTemplate = changeTemplate;
    customNotificationVm.isSubjectEmpty = isSubjectEmpty
    customNotificationVm.getTeacher = getTeacher

    activate()

    function activate () {
      return getCustomNotificationData()
      .then(function (){
        if($stateParams.notificationId){

          getNotification($stateParams.notificationId)
        }
        else{ 
           // $scope.selectedDeliveryType=true
          // console.log('ggg',customNotificationVm.selectedDeliveryType);
        }

      })
    }

    function getCustomNotificationData() {
      let header = { }
      if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)){
        header.userId = user.id
        header.rolId  = currentRoleId
      } 
      return GeneralSettingsSrv.customNotificationData.getList(header).$promise.then( (dataReturn) => {
        if(dataReturn.status == true){
          customNotificationVm.faculties = dataReturn.data.faculties
          customNotificationVm.teachers = dataReturn.data.teachers
          customNotificationVm.deliveryType = dataReturn.data.deliveryType
          customNotificationVm.submodules = dataReturn.data.submodules
          customNotificationVm.notificationTypes = dataReturn.data.notificationTypes
          customNotificationVm.templates = dataReturn.data.templates
        } else {
          console.log("Comunications problem with the server")
        }
      }, (data) => {
        console.log(data);
      })
    }



    function toggle(item) {
      let idx = customNotificationVm.selectedDeliveryType.indexOf(item);
      if (idx > -1) {
        customNotificationVm.selectedDeliveryType.splice(idx, 1)
      } else {
        customNotificationVm.selectedDeliveryType.push(item)
      }
    }

    function exists(item) {
      return customNotificationVm.selectedDeliveryType.indexOf(item) > -1
    }

    function saveCustomNotification() {
      customNotificationVm.isDisabled = true
      let data = {
        "asunto": customNotificationVm.asunto,
        "ds_description": customNotificationVm.comments,
        "id_create_notification_type": 2,
        "id_faculty": customNotificationVm.selectedFaculty.faculty_id,
        "dt_sending": moment(new Date(customNotificationVm.deliveryDate)).format('YYYY-MM-DD'),
        "ds_description_custom": customNotificationVm.comments,
        // "id_submodule": customNotificationVm.selectedModule.id_code,
        "id_teacher": customNotificationVm.selectedTeachers.map( (teacher) => {
          return teacher.teacher_id
        }).join(','),
        "specific_date": moment(new Date(customNotificationVm.deliveryDate)).format('YYYY-MM-DD'),
        "ds_days": "",
        "ds_days_before": "",
        "is_at_sending_moment": true,
        "id_schedule_notification_type": customNotificationVm.scheduleType,
        "start_date": "",
        "end_date": "",
        "is_undefined": false,
        "id_notificationType":customNotificationVm.selectedNotificationType.notification_type_id,
        "id_notification_delivery_type": customNotificationVm.selectedDeliveryType.map( (deliveryType) => {
          return deliveryType.delivery_type_id
        }).join(',')
      }

      if( $stateParams.notificationId)
        editCustomNotification(data)
      else
        createCustomNotification(data)
    }

    function createCustomNotification(notification) {
      GeneralSettingsSrv.createCustomNotification.save(notification).$promise.then( (dataReturn) => {
        if(dataReturn.status == true){
          $state.go('generalSettings.notificationsManagement')
        } else {
          customNotificationVm.isDisabled = false
          console.log("Comunications problem with the server")
        }
      }, (data) => {
        customNotificationVm.isDisabled = false
        console.log(data);
      })
    }

    function editCustomNotification(notification) {
      notification.id_notification = $stateParams.notificationId
      GeneralSettingsSrv.updateNotification.save(notification).$promise.then( (dataReturn) => {
        if(dataReturn.status == true){
          $state.go('generalSettings.notificationsManagement')
        } else {
          customNotificationVm.isDisabled = false
          console.log("Comunications problem with the server")
        }
      }, (data) => {
        customNotificationVm.isDisabled = false
        console.log(data)
      })
    }

    function addTeacher(teacher) {

      var flag=false;
      for(var i in customNotificationVm.selectedTeachers){
        if(customNotificationVm.selectedTeachers[i].teacher_id==teacher.teacher_id){
          flag=true;
        }
      }
      if( teacher && flag==false )
      {
        customNotificationVm.selectedTeachers.push(teacher)
        $scope.selectedItem = null
      }
    }

    function removeTeacher(teacher) {
      let idx = customNotificationVm.selectedTeachers.indexOf(teacher)
      customNotificationVm.selectedTeachers.splice(idx, 1)

      // customNotificationVm.teachers.shift(teacher);
      // console.log(customNotificationVm.teachers)
    }

    function searchTeacher(teacher) {  
      let matcher = new RegExp(teacher,'i')
      let arr = []
     if(typeof customNotificationVm.selectedFaculty !== 'undefined'){
          return GeneralSettingsSrv.getTeacherByfacultyId.get({ID_FACULTY: customNotificationVm.selectedFaculty.faculty_id,TEXT:teacher})
            .$promise.then(function(dataReturn) {
            if( dataReturn.status == true ){  
             customNotificationVm.teachers = dataReturn.data.faculties;
              customNotificationVm.teachers.forEach((teacher) => {
                if (teacher.teacher_name.match(matcher)) {
                    arr.push(teacher)
                }
              })
              return arr
            }
            else{}

            },function(data) {
            console.log(data)
            })
     }else{
      return  arr;
     }
    }

    function hasError(input){
      if( input.$invalid && (input.$dirty || input.$touched ) )
        return 'has-error';
    }

    function changeTemplate( selectedTemplate ) { 
      customNotificationVm.comments = selectedTemplate.ds_description;
    }

    function showErrorMessages(input)
    {
      return input.$dirty || input.$touched;
    }

    function validateForm(form){
        return form.$invalid;
    }

    function isSubjectEmpty(){

       if( customNotificationVm.asunto ){
          return false
        }
      return true
    }

    function getNotification(notificationId) { 
      return GeneralSettingsSrv.getNotificationById.get({notificationId: notificationId})
      .$promise.then(function(dataReturn) {
        if( dataReturn.status == true ){  
          if( dataReturn.data )
            formatNotification( dataReturn.data[0] )
        }
        else{}

        },function(data) {
          console.log(data)
      })
    }

    function formatNotification(notification) { 
      customNotificationVm.deliveryDate = moment(notification.dt_sending, 'YYYY-MM-DD').toDate()
      customNotificationVm.asunto = notification.asunto
      customNotificationVm.comments = notification.ds_description_custom
      customNotificationVm.selectedNotificationType = getNotificationTypeSelected(notification)
      customNotificationVm.selectedFaculty = getFacultySelected(notification)
      // customNotificationVm.selectedModule = getSubmoduleSelected(notification)
      console.log('ffff',setDeliveryTypeSelected(notification));
       customNotificationVm.selectedDeliveryType = setDeliveryTypeSelected(notification)
      customNotificationVm.selectedTeachers = setSelectedTeachers(notification)
      customNotificationVm.scheduleType = notification.id_schedule_notification_type
    }


    function getTeacher(selectedFaculty){
      // alert(JSON.stringify(selectedFaculty));
    if(typeof selectedFaculty !=='undefined'){
         GeneralSettingsSrv.getTeacherByfacultyId.get({ID_FACULTY: selectedFaculty.faculty_id})
        .$promise.then(function(dataReturn) {
          if( dataReturn.status == true ){  
           
                       // $scope.searchText = undefined;  
                       customNotificationVm.teachers=[];
                       customNotificationVm.teachers = dataReturn.data.faculties;
                       customNotificationVm.teachertemp = dataReturn.data.faculties;
                       customNotificationVm.selectedTeachers=dataReturn.data.faculties;
                       $scope.selectedItem = null
          }
          else{}

          },function(data) {
            console.log(data)
        })
    }


    }


    function setSelectedTeachers(notification) {   
      let teacherArray = []
      console.log(notification);
      if (notification.id_teacher){
        teacherArray = notification.id_teacher.split(',')
        teacherArray = teacherArray.map( teacherId => parseInt(teacherId) )
      }
      return customNotificationVm.teachers.filter(
        (teacher) => {
          return teacherArray.includes(teacher.teacher_id)
      })
    }

    function getNotificationTypeSelected(notification){
      for(var index in customNotificationVm.notificationTypes){
        if(customNotificationVm.notificationTypes[index].notification_type_id == notification.id_notificationType)
          return customNotificationVm.notificationTypes[index]
      }
    }

    function getFacultySelected(notification){
      for(var index in customNotificationVm.faculties){
        if(customNotificationVm.faculties[index].faculty_id == notification.id_faculty)
          return customNotificationVm.faculties[index]
      }
    }

    function getSubmoduleSelected(notification){
      for(var index in customNotificationVm.submodules){
        if(customNotificationVm.submodules[index].id_code == notification.id_submodule)
          return customNotificationVm.submodules[index]
      }
    }

    function setDeliveryTypeSelected(notification){
      var result = []
      var idsSelected = []
      if(notification.id_notification_delivery_type.indexOf(",") > -1)
        idsSelected = notification.id_notification_delivery_type.split(",")
      else
        idsSelected.push(notification.id_notification_delivery_type)

      for(var index in customNotificationVm.deliveryType){
        if(idsSelected.indexOf(customNotificationVm.deliveryType[index].delivery_type_id.toString()) > -1)
          result.push(customNotificationVm.deliveryType[index])
      }
      return result
    }

	}//FIN DEL CONSTRUCTOR

    preventInput(event){
    var  vKey = 86
    if (event.keyCode == vKey)
      event.preventDefault()
    return;     
  }
}

CustomNotificationCtrl.$inject = ['$scope', '$state', 'GeneralSettingsSrv','$stateParams','$timeout','$cookies', 'Validations'];


// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/notifications/custom/customNotificationCtrl.js